var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"field",class:("field-" + _vm.idMatch),attrs:{"frameborder":"0","scrolling":"no"},on:{"load":_vm.resize}})}
var staticRenderFns = []

export { render, staticRenderFns }